import './style.modules.scss'

import React from 'react'

import { HorizontalTabs, HorizontalTabsProps } from './HorizontalTabs'
import { VerticalTabs, VerticalTabsProps } from './VerticalTabs'

export type TabsProps = {
  orientation: 'horizontal' | 'vertical'
} & (HorizontalTabsProps | VerticalTabsProps)

export const Tabs = (props: TabsProps) => {
  if (props.orientation === 'horizontal') {
    return <HorizontalTabs {...(props as HorizontalTabsProps)} />
  } else {
    return <VerticalTabs {...(props as VerticalTabsProps)} />
  }
}
